// @flow

import React from "react";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router";
import { Form as FoForm, Field, ErrorMessage } from "formik";

import { Button, Card, Form } from "tabler-react";

const SettingsIntegrationTelegramForm = ({
    t,
    history,
    isSubmitting,
    errors,
    values,
    returnUrl,
}) => (
    <FoForm>
        <Card.Body>
            <Form.Group label={t("settings.integration.telegram.bot_token")}>
                <Field
                    type="text"
                    name="telegram_bot_token"
                    className={
                        errors.telegram_bot_token
                            ? "form-control is-invalid"
                            : "form-control"
                    }
                    autoComplete="off"
                />
                <ErrorMessage
                    name="telegram_bot_token"
                    component="span"
                    className="invalid-feedback"
                />
            </Form.Group>
            <Form.StaticText>
                {t("settings.integration.telegram.bot_token_explanation")}
            </Form.StaticText>

            <Form.Group label={t("settings.integration.telegram.bot_username")}>
                <Field
                    type="text"
                    name="telegram_bot_username"
                    className={
                        errors.telegram_bot_username
                            ? "form-control is-invalid"
                            : "form-control"
                    }
                    autoComplete="off"
                    placeholder="@your_bot_username"
                />
                <ErrorMessage
                    name="telegram_bot_username"
                    component="span"
                    className="invalid-feedback"
                />
            </Form.Group>
            <Form.StaticText>
                {t("settings.integration.telegram.bot_username_explanation")}
            </Form.StaticText>
        </Card.Body>
        <Card.Footer>
            <Button color="primary" type="submit" disabled={isSubmitting}>
                {t("general.submit")}
            </Button>
        </Card.Footer>
    </FoForm>
);

export default withTranslation()(withRouter(SettingsIntegrationTelegramForm));
